module.exports = __webpack_public_path__ + "img/bul_info_help.46715b71.svg";